export const SEGMENT_CONFIGS = {
  compact: {
    faltantes: {
      textSize: 'text-xs',
      segments: [
        { prop: 'facturadasCount',           dotColor: 'bg-purple-500', label: 'Facturadas',          hideIfZero: false },
        { prop: 'controlFacturadasCount',    dotColor: 'bg-red-600',    label: 'Unidades en salida',  hideIfZero: true,  accent: true },
        { prop: 'inventarioSinEscanearCount',dotColor: 'bg-blue-500',   label: 'Inventario',          hideIfZero: true },
      ],
    },
    porLlegar: {
      textSize: 'text-[12.65px]',
      segments: [
        { prop: 'facturadasPorLlegarCount',  dotColor: 'bg-purple-500', label: 'Facturadas',  hideIfZero: true },
        { prop: 'inventarioPorLlegarCount',  dotColor: 'bg-blue-500',   label: 'Inventario',  hideIfZero: true },
      ],
    },
  },
  expanded: {
    textSize: 'text-xs',
    segments: [
      { prop: 'facturadasCount',        dotColor: 'bg-purple-500', label: 'Facturadas',         hideIfZero: false },
      { prop: 'controlFacturadasCount', dotColor: 'bg-red-600',    label: 'Unidades en salida', hideIfZero: true, accent: true },
    ],
  },
};
